import { AxiosResponse } from 'axios';
import { BaseApiClient } from './BaseAPIClient';

export class AssetApiClient extends BaseApiClient {
  constructor() {
    super(BaseApiClient.findBaseUrl());
  }

  /**
   * Get Asset Download Url
   * @description Get a signed url for downloading an asset binary
   * @param assetId Asset ID
   * @param albumId Album ID the asset belongs to
   */
  async getAssetDownloadUrl(assetId: string, albumId: string): Promise<any> {
    const path = `/prs/api/v1/assets/${assetId}/download?albumId=${albumId}`;
    return await this.get(path);
  }

  async getThumbnailDownloadUrl(
    assetId: string,
    albumId: string
  ): Promise<any> {
    const path = `/prs/api/v1/assets/${assetId}/download/thumbnail?albumId=${albumId}`;
    return await this.get(path);
  }

  async createMultipartUploadId(): Promise<AxiosResponse> {
    return await this.get('/prs/api/v1/AwsS3MultipartUpload/UploadId');
  }

  async initializeMultipartUpload(
    filename: string,
    fileType: string,
    filePath: string
  ): Promise<any> {
    const s3UploadParams = { filename, fileType, filePath };
    return await this.post(
      '/prs/api/v1/AwsS3MultipartUpload/Init',
      s3UploadParams
    );
  }

  async getMultipartUploadUrl(
    uploadId: string,
    partNumber: number,
    uploadKey: string
  ): Promise<any> {
    return await this.get(
      `/prs/api/v1/AwsS3MultipartUpload/${uploadId}/${partNumber}?key=${uploadKey}`
    );
  }

  async completeMultipartUpload(
    uploadId: string,
    uploadKey: string,
    partsJson: string
  ) {
    return await this.post(
      `/prs/api/v1/AwsS3MultipartUpload/${uploadId}/complete?createAsset=true&key=${uploadKey}`,
      partsJson
    );
  }

  async abortMultipartUpload(uploadId: string, uploadKey: string) {
    return await assetApiClient.delete(
      `/prs/api/v1/AwsS3MultipartUpload/${uploadId}/Abort?key=${uploadKey}`
    );
  }
}

export const assetApiClient = new AssetApiClient();
